import { components } from "@certn/legacy-api/generated-schemas/people";
import { t } from "i18next";
import { date, lazy } from "yup";

import { DateInputField } from "./DateInputField";
import { DateSummaryField } from "./DateSummaryField";
import { FieldType } from "../types";

export function DateField(
  field: components["schemas"]["DateCheckField"]
): FieldType<components["schemas"]["DateCheckField"]> {
  return {
    field,
    inputElement: <DateInputField key={field.name} field={field} />,
    summaryElement: () => <DateSummaryField key={field.name} field={field} />,
    schema: dateFieldSchema(field),
    initialValue: field.value,
  };
}

export function dateFieldSchema(
  field: components["schemas"]["DateCheckField"]
) {
  return lazy(() => {
    let schema = date();

    if (field.required) {
      schema = schema.required(t("This field is required"));
    }

    if (!field.allow_future_date) {
      schema = schema.max(new Date(), t("Invalid date"));
    }

    if (!field.allow_past_date) {
      schema = schema.min(new Date(), t("Invalid date"));
    }

    if (field.min_age) {
      const latestDate = new Date();
      latestDate.setFullYear(latestDate.getFullYear() - field.min_age);
      schema = schema.max(
        latestDate,
        t("You must be at least {{min_age}} years old", {
          min_age: field.min_age,
        })
      );
    }

    return schema;
  });
}
